import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PostManagementForm = lazy(
  () => import('@components/Group/Portfolio/PostManagementForm')
);

/** 포트폴리오 상세 > 사후관리 > 수정하기 */
const PostManagementEdit = () => {
  return (
    <ApiErrorBoundary>
      <Suspense>
        <PostManagementForm mode="edit" />
      </Suspense>
    </ApiErrorBoundary>
  );
};

export default PostManagementEdit;
